import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    gap: 14px;
  }
`;

export const Button = styled.button`
  display: block;
  background-color: transparent;
  border: none;
`;
